import { EventVisibility } from "../../generated/drinks_pb";
import type { TFunction } from "i18next";

const VISIBILITY_OPTION_DEFS = [
    { value: EventVisibility.EVENT_VISIBILITY_PUBLIC, color: "green", labelKey: "eventStats.visibilityOptions.public" },
    { value: EventVisibility.EVENT_VISIBILITY_FRIENDS, color: "blue", labelKey: "eventStats.visibilityOptions.friends" },
    { value: EventVisibility.EVENT_VISIBILITY_PASSWORD, color: "orange", labelKey: "eventStats.visibilityOptions.password" },
    { value: EventVisibility.EVENT_VISIBILITY_PRIVATE, color: "red", labelKey: "eventStats.visibilityOptions.private" },
];

export const buildEventVisibilityOptions = (t: TFunction) => {
    const options = VISIBILITY_OPTION_DEFS.map((option) => ({
        value: option.value,
        color: option.color,
        label: t(option.labelKey),
    }));
    return { options, optionMap: new Map(options.map((option) => [option.value, option])) };
};
